import { DefaultLimits } from "constants/DefaultLimits";
import {
    selectAgentHasRead,
    selectIsConversationAgeLimitReached,
    selectIsScorableInReview,
} from "features/scorable/scorableSlice";
import { useStrings } from "features/i18n/useStrings";
import {
    GuxFormFieldCheckbox,
    GuxTooltip,
} from "genesys-spark-components-react";
import strings from "./footer.strings";
import { useAppSelector } from "app/hooks";
import "./EvaluationReviewCheck.less";

export default function EvaluationReviewCheck({
    isAdmin,
    onChange,
    evaluationReviewed,
}: {
    isAdmin: boolean;
    onChange: (value: boolean) => void;
    evaluationReviewed: boolean;
}) {
    const hasAgentReviewed = useAppSelector(selectAgentHasRead);
    const hasAgentReviewExpired = useAppSelector((state) => {
        return selectIsConversationAgeLimitReached(
            state,
            DefaultLimits.agentReviewExpiry
        );
    });
    const t = useStrings(strings);
    const isStatusInReview = useAppSelector(selectIsScorableInReview);
    const disabled =
        isAdmin ||
        hasAgentReviewed ||
        hasAgentReviewExpired ||
        isStatusInReview;

    return (
        <div
            className="EvaluationReviewCheck"
            data-testid="evaluation-review-check"
        >
            <GuxFormFieldCheckbox>
                <input
                    slot="input"
                    type="checkbox"
                    disabled={disabled}
                    aria-disabled={disabled}
                    checked={hasAgentReviewed || evaluationReviewed}
                    onChange={() => onChange(!evaluationReviewed)}
                    onKeyDown={(event) => {
                        event.key === "Enter" && onChange(!evaluationReviewed);
                    }}
                    className={disabled ? "" : "Clickable"}
                />
                <label slot="label" className={disabled ? "" : "Clickable"}>
                    {isAdmin
                        ? t.labels.agentHasReviewed
                        : t.labels.reviewedEvaluation}
                </label>
            </GuxFormFieldCheckbox>
            {hasAgentReviewExpired && (
                <GuxTooltip>
                    {t.labels.agentReviewExpired({
                        agentReviewExpiry: DefaultLimits.agentReviewExpiry,
                    })}
                </GuxTooltip>
            )}
        </div>
    );
}
